import { render } from "./NewCard.vue?vue&type=template&id=9c56d010"
import script from "./NewCard.vue?vue&type=script&lang=ts"
export * from "./NewCard.vue?vue&type=script&lang=ts"
script.render = render

export default script